const en = require('./en.json')
const es = require('./es.json')

export {
     en, es
}